export const ACTION_COMMON_START = 'ACTION_COMMON_START';
export const ACTION_COMMON_END = 'ACTION_COMMON_END';
export const SET_TOASTER_MESSAGE = 'SET_TOASTER_MESSAGE';
export const SET_TOGGLE_CLASS = 'SET_TOGGLE_CLASS';

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
